import React from "react"
import PropTypes from "prop-types"
import classnames from "classnames"
import check from "images/components/check.svg"

import {
  sendPlatformSuggestion,
  platformUpdateSubscription,
} from "shared/lib/graphql"
import { rejectedXHRPromiseLogger } from "shared/lib/xhr_promise"
import Modal from "shared/components/modal"
import displayFlash from "partners/scripts/display_flash"

import "./platform-suggestion.scss"

export default class PlatformSuggestion extends React.Component {
  state = {
    modalOpen: false,
    suggestionName: this.props.suggestionName,
    suggestionText: "",
    submittedSuggestion: false,
    showEmailCheckbox: this.props.suggestionName.length == 0,
    allowEditSuggestionName: this.props.suggestionName.length == 0,
    sendEmail: false,
    checkInput: false,
  }

  toggleModal = () => {
    this.setState({ modalOpen: !this.state.modalOpen })
  }

  toggleSendEmail = () => {
    this.setState({ sendEmail: !this.state.sendEmail })
  }

  handleSendEmail = () => {
    if (this.state.sendEmail) {
      platformUpdateSubscription(parseInt(this.props.channelId), {
        [this.props.suggestionType]: true,
      }).catch(
        rejectedXHRPromiseLogger(() => {
          displayFlash("Failed to subscribe to updates")
        })
      )
    }

    this.setState({ modalOpen: false })
  }
  updateSuggestionName = e => {
    this.setState({ suggestionName: e.target.value })
  }

  updateSuggestionText = e => {
    this.setState({ suggestionText: e.target.value })
  }

  postSuggestion = () => {
    let { suggestionName, suggestionText } = this.state
    suggestionName = suggestionName.trim()
    suggestionText = suggestionText.trim()
    if (!(suggestionName && suggestionText)) {
      this.setState({ checkInput: true })
      return
    }
    const { channelId, suggestionType, contextChannelId } = this.props
    sendPlatformSuggestion(
      parseInt(channelId),
      suggestionType,
      suggestionName,
      suggestionText,
      parseInt(contextChannelId) || null
    )
      .then(mutation => {
        if (mutation.errors.length) {
          this.setState({ modalOpen: !this.state.modalOpen })
          throw new Error("Suggestion failed ", mutation.errors)
        } else {
          this.setState({ submittedSuggestion: true, checkInput: false })
        }
      })
      .catch(
        rejectedXHRPromiseLogger(() => {
          displayFlash(
            "Failed to save the suggestion. Try again later",
            "error"
          )
        })
      )
  }

  emailPhrase() {
    const { suggestionType } = this.props
    if (suggestionType === "applet") {
      return `Email me when ${this.props.serviceName} publishes a new Applet.`
    } else if (suggestionType === "service") {
      return `Email me when a new service is published on IFTTT.`
    } else {
      return `Email me  when ${this.props.serviceName} adds queries, triggers, or actions.`
    }
  }

  render() {
    let displaySuggestionType = this.props.suggestionType
    if (this.props.suggestionType === "protocol") {
      displaySuggestionType = "service"
    } else if (this.props.suggestionType === "applet") {
      displaySuggestionType = "Applet"
    }

    const stylenames = classnames("platform-suggestion", {
      inline: this.props.displayInline,
    })

    const containerStyles = classnames("container", {
      inline: this.props.displayInline,
    })

    return (
      <div styleName={containerStyles}>
        {this.props.suggestionType == "protocol" ? (
          <button
            styleName="suggestion-button protocol"
            className="button-tertiary"
            onClick={this.toggleModal}
          >{`Make a suggestion`}</button>
        ) : (
          <div styleName={stylenames}>
            {"Don't see what you're looking for?"}
            {this.props.displayInline ? (
              <p
                styleName="modal-anchor"
                onClick={this.toggleModal}
              >{`Suggest a new ${displaySuggestionType}`}</p>
            ) : (
              <button
                styleName="suggestion-button"
                className="button-tertiary"
                onClick={this.toggleModal}
              >{`Suggest a new ${displaySuggestionType}`}</button>
            )}
          </div>
        )}
        <Modal
          closeListener={this.toggleModal}
          moveCloseXToHeader
          leftJustifyHeader
          headerText={
            this.state.submittedSuggestion
              ? "Thank You."
              : `Suggest a new ${displaySuggestionType} to ${this.props.serviceName}`
          }
          headerSubText={
            this.state.submittedSuggestion
              ? `Your suggestion was sent to the creator. Thanks for taking the time to help them improve.`
              : ""
          }
          show={this.state.modalOpen}
        >
          {this.state.submittedSuggestion ? (
            <>
              {this.state.showEmailCheckbox && (
                <div styleName="margin-bottom flex">
                  <span
                    styleName="checkbox"
                    onClick={this.toggleSendEmail}
                    dangerouslySetInnerHTML={{
                      __html: this.state.sendEmail ? check : "",
                    }}
                  />
                  <span styleName="email-me">{this.emailPhrase()}</span>
                </div>
              )}
              <button
                className="button-tertiary"
                onClick={this.handleSendEmail}
              >
                Done
              </button>
            </>
          ) : (
            <>
              <p styleName="suggestion-prompt">
                What new {displaySuggestionType} would you like to see on IFTTT?
              </p>
              <input
                styleName="no-globals"
                type="text"
                value={this.state.suggestionName}
                onChange={this.updateSuggestionName}
                disabled={!this.state.allowEditSuggestionName}
              />
              <p styleName="suggestion-prompt">
                How would you use this {displaySuggestionType}?
              </p>
              <textarea
                styleName="margin-bottom noresize"
                type="text"
                value={this.state.suggestionText}
                onChange={this.updateSuggestionText}
              />
              {this.state.checkInput && (
                <p styleName="suggestion-prompt check-input">
                  Please describe your suggestion
                </p>
              )}
              <button className="button-tertiary" onClick={this.postSuggestion}>
                Submit
              </button>
            </>
          )}
        </Modal>
      </div>
    )
  }
}

PlatformSuggestion.propTypes = {
  suggestionType: PropTypes.string,
  channelId: PropTypes.string,
  displayInline: PropTypes.bool,
  serviceName: PropTypes.string,
  contextChannelId: PropTypes.string,
  suggestionName: PropTypes.string,
}

PlatformSuggestion.defaultProps = {
  displayInline: false,
  suggestionType: "service",
  serviceName: "IFTTT",
  channelId: "1240189002",
  contextChannelId: null,
  suggestionName: "",
}
